/**
 * Renderer Utilities — Shared helpers for question renderers.
 *
 * Extracted during practice audit R2-DUP1 to deduplicate hexToRgba
 * and FALLBACK_COLOR across ErrorSpotting, SentenceErrorJudge, and
 * TrueFalseSeries renderers.
 */

import type { CSSProperties } from 'react'

/**
 * Extended CSSProperties that allows Tailwind CSS custom properties (--tw-*)
 * in inline style objects without @ts-ignore. (R3-T2)
 */
export type TailwindCSSProperties = CSSProperties & Record<`--${string}`, string>

/** Default module accent color (indigo-500) used when no moduleColor is provided */
export const FALLBACK_COLOR = '#6366F1'

/** Convert a hex color string to an rgba() CSS value */
export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}